/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
import useEnhancedEffect from "../useEnhancedEffect/index.js";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = React.useRef(fn);
    useEnhancedEffect(()=>{
        ref.current = fn;
    });
    return React.useRef(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return(// @ts-expect-error hide `this`
        (0, ref.current)(...args));
    }).current;
}
export default useEventCallback;
